import axios from '../../axiosInstance';

const loginApibasUrl = '/login'

class LoginService{

    Login(details){
        return axios.post(loginApibasUrl+'/Login',details)
    }

}

export default new LoginService();